import { ClipLoader } from "react-spinners";

function LoadingIndicator(visiblity, color, size) {
  return (
    <div className="flex justify-center items-center h-screen">
      <ClipLoader color={color} loading={visiblity} size={size} />
    </div>
  );
}

export default LoadingIndicator;
